import { SaleOrder } from '@/domain/SaleOrder';
import { Services } from '@/infra/services';
import { type Meta } from '@/infra/services/sale-order/get-sale-orders';

import { baseSaleOrderAdapter } from './adapter';

const ORDERS_PER_PAGE = 20;

export interface GetSaleOrdersResult {
  data: SaleOrder[];
  meta: Meta;
}

export async function getSaleOrders(
  page: number
): Promise<GetSaleOrdersResult> {
  const response = await Services.SaleOrder.getSaleOrders({
    page,
    perPage: ORDERS_PER_PAGE,
  });

  const data = response.data.map((saleOrder) => {
    const domainProps = baseSaleOrderAdapter(saleOrder);

    return new SaleOrder(domainProps);
  });

  return {
    data,
    meta: response.meta,
  };
}
